import { IAxiosResponse, IPaginator, ISearch } from '../store/ducks/root.types'
import { FollowUp, StatusPatient } from '../store/application/models/followUp/followUp'
import axiosInstance from './axios'
import { PatientFilter } from '../components/table/follow.up.consultation/list'
import { CancelTokenSource } from 'axios'

class FollowUpService {


  constructor(private apiVersion: string = 'v1') {
  }

  // pesquisa todos o acompanhamentos de um paciente especifico
  public async getAll(
    patientId: string,
    paginator?: IPaginator,
    filter?: ISearch,
    source?: CancelTokenSource
  ): Promise<IAxiosResponse<FollowUp[]>> {
    const params: URLSearchParams = this.buildParams(paginator, filter)
    return axiosInstance
      .get(
        `${this.apiVersion}/patients/${patientId}/followups`,
        { params, cancelToken: source?.token }
      )
      .then((response) => {
        return {
          data: response.data.map((data: any) => new FollowUp().fromJSON(data)),
          headers: response.headers
        }
      })
  }

  // cria um novo acompanhamento
  public async create(patientId: string): Promise<IAxiosResponse<FollowUp>> {
    return axiosInstance
      .post(`${this.apiVersion}/patients/${patientId}/followups`,
        { patient_id: patientId, created_at: new Date(), active: true, stage: StatusPatient.TRACKING.toLowerCase() })
      .then((response) => {
        return {
          data: new FollowUp().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  public async getById(patientId: string, followUpId: string): Promise<IAxiosResponse<FollowUp>> {
    return axiosInstance
      .get(`${this.apiVersion}/patients/${patientId}/followups/${followUpId}`,)
      .then((response) => {
        return {
          data: new FollowUp().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  public async updadeFollowUp(newFollowUp: FollowUp): Promise<IAxiosResponse<FollowUp>> {
    const followUp = newFollowUp.toJSON()
    return axiosInstance
      .patch(`${this.apiVersion}/patients/${newFollowUp.patient_id}/followups/${newFollowUp.id}`,
       { ...followUp })
      .then((response) => {
        return {
          data: new FollowUp().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  public buildParams(paginator?: IPaginator, filter?: ISearch): URLSearchParams {
    const params = new URLSearchParams()
    if (paginator) {
      const hasSearch = (paginator?.search?.key === 'name' && paginator?.search?.value) ||
        (paginator?.search?.key === 'cpf' && paginator?.search?.value)

      if (paginator.page && !hasSearch) {
        params.append('page', String(paginator.page + 1))
      }
      if (paginator.rows) {
        params.append('limit', String(paginator.rows))
      }
      if (hasSearch) {
        params.append(`${paginator?.search?.key}_like`, `${paginator?.search?.value}`)
      }

    }
    if (filter?.key === "created_at") {
      params.append("sort", `${filter?.value === PatientFilter.RECENT ? `-${filter?.key}` : `${filter?.key}`}`)
    }
    if (filter?.key === "open_follow_up") {
      params.delete('limit')
      params.delete('page')
      params.append("conducts.stage", `${filter?.value}`)
    }
    return params
  }
}
const folloUpService = new FollowUpService()
export default folloUpService